import { ChangeDetectionStrategy, Component, output, input } from '@angular/core';
import { NgClass } from '@angular/common';
import { IconUIComponent } from '../icon/icon.component';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'fr8bot-select-primary-image-button',
  imports: [NgClass, IconUIComponent, TranslatePipe],
  templateUrl: './select-primary-image-button.html',
  styleUrl: './select-primary-image-button.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SelectPrimaryImageButton {
  readonly selected = input<boolean>();
  readonly labelBottom = input<boolean>();
  readonly disabled = input<boolean>();

  readonly selectItem = output<void>();
}
